import { RouteRecordRaw } from 'vue-router'
import { middleware } from '@/helpers/auth'

const profileRoutes: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/profile/ProfileView.vue'),
    beforeEnter: [middleware.isAuth]
  },
  {
    path: '/profile/account',
    name: 'profile-account',
    component: () => import('@/views/profile/ProfileAccountView.vue'),
    beforeEnter: [middleware.isAuth]
  },
  {
    path: '/profile/nickname',
    name: 'profile-nickname',
    component: () => import('@/views/profile/ProfileNicknameView.vue'),
    beforeEnter: [middleware.isAuth]
  },
  {
    path: '/profile/password',
    name: 'profile-password',
    component: () => import('@/views/profile/ProfilePasswordView.vue'),
    beforeEnter: [middleware.isAuth]
  },
  {
    path: '/profile/photo',
    name: 'profile-photo',
    component: () => import('@/views/profile/ProfilePhotoView.vue'),
    beforeEnter: [middleware.isAuth]
  }
]

export default profileRoutes
